module.exports = __webpack_public_path__ + "static/media/sciendomus.558a35a1.mp3";